var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Star_svg__clip0_8123_50679)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.14 7.83a10.783 10.783 0 011.572-3.94.523.523 0 00-.875-.57 11.884 11.884 0 00-1.723 4.317.524.524 0 00.416.61.524.524 0 00.61-.418z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.978 5.59c-.896.559-1.794 1.112-2.686 1.677a.522.522 0 00.558.88c.89-.563 1.786-1.115 2.682-1.673a.522.522 0 00-.554-.883zM13.655 9.088c-1.204-.1-2.382-.316-3.572-.531a.519.519 0 00-.606.42.519.519 0 00.42.605c1.22.222 2.434.442 3.673.547a.522.522 0 00.085-1.041z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.62 13.158a52.4 52.4 0 01-2.643-4.873.522.522 0 00-.946.446 54.531 54.531 0 002.697 4.97c.15.246.473.324.718.175a.524.524 0 00.174-.718z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.187 7.595c-.66 1.637-1.279 3.296-2.033 4.892a.521.521 0 10.944.445c.762-1.615 1.388-3.292 2.055-4.948a.521.521 0 00-.966-.389z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.003 8.083c-1.108.942-2.262 1.669-3.516 2.382a.521.521 0 10.515.905c1.314-.746 2.518-1.507 3.679-2.493a.522.522 0 00-.678-.794z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.123 8.069c-1.888.073-3.744.596-5.63.6a.521.521 0 00.003 1.044c1.897-.004 3.764-.528 5.668-.6a.526.526 0 00.503-.542.525.525 0 00-.544-.502z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.685 8.291c-1.071-1.33-2-2.738-2.991-4.125a.52.52 0 10-.849.607c1 1.403 1.944 2.825 3.027 4.174.181.221.511.258.734.078a.52.52 0 00.079-.734z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.944 8.936c-.153-.312-.291-.611-.41-.932a.522.522 0 10-.98.365c.134.355.286.685.455 1.027.127.258.44.366.698.235a.52.52 0 00.237-.695z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Star_svg__clip0_8123_50679"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "rotate(61.202 4.432 9.378)",
    d: "M0 0h12v12H0z"
  })))));
};
export default SvgStar;